import React from 'react';
import { ExternalLinks } from '../components/ExternalLinks';

export const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
        <div className="bg-white rounded-xl shadow-md p-8 prose prose-lg">
          <p className="text-gray-600 mb-8">Effective: January 1, 2024</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">About Our Service</h2>
            <p>Secure Anonymous TempMail provides temporary email addresses for anonymous communication.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Acceptable Use</h2>
            <p className="mb-4">You agree to use this service responsibly and lawfully:</p>
            <ul className="list-disc pl-6">
              {[
                'No illegal activities',
                'No spamming or phishing',
                'No harassment',
                'No system exploitation'
              ].map((item, index) => (
                <li key={index} className="mb-2">{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Service Limitations</h2>
            <p>Our temporary email service may have message retention limitations and availability constraints. Emails are automatically deleted after 24 hours.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Disclaimer</h2>
            <p>This service is provided "as is" without warranties of any kind. We are not responsible for content received through temporary email addresses.</p>
          </section>
        </div>

        <ExternalLinks type="terms" />
      </div>
    </div>
  );
};